import CourseDetail from "@/views/Course/CourseDetail";
import CourseEdit from "@/views/CourseEdit/index";
import TheoryManage from "@/views/QuestionBank/theory/index";
import PracticalManage from "@/views/QuestionBank/practical/index";
import DictData from "@/views/system/Dict/data/index";

/** 不在菜单中展示、但需要静态保留的路由 */
export const hiddenRoutes = [
  {
    path: "/course/detail",
    name: "课程详情",
    component: CourseDetail,
    hidden: true,
    meta: {
      title: "课程详情",
      requireAuth: true
    }
  },
  {
    path: "/course/edit",
    name: "课程信息",
    component: CourseEdit,
    hidden: true,
    meta: {
      title: "课程信息",
      requireAuth: true
    }
  },
  {
    path: "/question/theory/manage",
    name: "理论题库列表",
    component: TheoryManage,
    hidden: true,
    meta: {
      title: "理论题库列表",
      requireAuth: true
    }
  },
  {
    path: "/question/practical/manage",
    name: "实操题库列表",
    component: PracticalManage,
    hidden: true,
    meta: {
      title: "实操题库列表",
      requireAuth: true
    }
  },
  {
    path: "/system/dict/data",
    name: "字典数据",
    component: DictData,
    hidden: true,
    meta: {
      title: "字典数据",
      requireAuth: true
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/hiddenRoutes.js